// extracted by mini-css-extract-plugin
module.exports = {"container":"image-question_container__26-KY","questionImage":"image-question_questionImage__2xMdI"};